export default __webpack_public_path__ + "static/media/Whistleblowing_1_(EN).c926b326.mp4";